'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _utilsBorder = require('./utils/border');

var _utilsBorder2 = _interopRequireDefault(_utilsBorder);

var _ImageBox = require('./ImageBox');

var _ImageBox2 = _interopRequireDefault(_ImageBox);

var Box = function Box(props) {
	var style = { display: 'flex', flexWrap: 'wrap', alignItems: 'stretch' };

	//size
	if (!!props.height) style.height = props.height;
	if (!!props.width) style.width = props.width;
	if (!!props.minWidth) style.minWidth = props.minWidth;
	if (!!props.minHeight) style.minHeight = props.minHeight;

	if (!!props.flexDirection) style.flexDirection = props.flexDirection;
	if (!!props.alignContent) style.alignContent = props.alignContent;

	//border
	(0, _utilsBorder2['default'])(style, props.border);
	if (!_lodash2['default'].isArray(props.images)) return _react2['default'].createElement('div', null);
	return _react2['default'].createElement(
		'div',
		{ style: style },
		props.images.map(function (image, index) {

			var imageProps = _lodash2['default'].extend({ url: image.url, flexGrow: index % 3, minWidth: 0, minHeight: 0 }, props.image);
			return _react2['default'].createElement(_ImageBox2['default'], _extends({ key: index }, imageProps));
		})
	);
};
var DEFAULT_IMAGE_URL = "data:image/gif;base64,R0lGODlhAQABAIAAAHd3dwAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==";
Box.defaultProps = { images: [{ url: DEFAULT_IMAGE_URL }], minWidth: 100, minHeight: 100 };
exports['default'] = Box;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-photo-widget-factory/lib/widgets/ImageFlexBox.js
 ** module id = 2221
 ** module chunks = 0
 **/